module.exports = __webpack_public_path__ + "static/media/staff.ecba082f.svg";